export default "__VITE_ASSET__CPAzaggZ__"